

const randomPartial = require('../internal/randomPartial');
const rgbToHsl = require('../rgb/toHsl');
const rgbToHex = require('../rgb/toHex');

module.exports = (format = 'hex') => {
  format = format.toLocaleLowerCase();
  let rgb = {
    'red': randomPartial(),
    'green': randomPartial(),
    'blue': randomPartial()
  };
  return format === 'rgb' ? rgb : format === 'hsl' ? rgbToHsl(rgb) : `#${rgbToHex(rgb)}`;
};


// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hex/random.js